import { css } from "styled-components";
import useMediaQuery from "../../../../../common/ui/useMediaQuery";

const smallMediaQuery = `(max-width: 767px),
(min-aspect-ratio: 13/9) and (max-width: 1023px)`;

export const styledSmallMediaQuery = (args) => css`
  @media ${smallMediaQuery} {
    ${css(args)};
  }
`;

export default function useIsTinyScreen() {
  const isTinyScreen = useMediaQuery(smallMediaQuery);

  return isTinyScreen;
}
